import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';
import css from './points.scss';

const Points = ({ value }) => (
  <h3 className={css.points}>
    <div className={css.value}>
      {value}
    </div>
    <div className={css.label}><Trans>Points earned</Trans></div>
  </h3>
);

Points.propTypes = {
  value: PropTypes.number
};

export default Points;
